<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'GROUPS'" [breadcrumb]="''" [count]="count"
  icon="fa-layer-group">
</app-breadcrumb>
<div class="content-background">
  <div class="row">
    <div class="col-sm-12">
      <div class="inputWithIcon inputWithIcon-search float-right d-flex">
        <app-advanced-mode id="groupGridAdvancedSwitch" [storageKey]="'groups-list'"
          (collapsibleToggle)="enableAdvanced=$event">
        </app-advanced-mode>
        <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-NAME' | translate }}"
          (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-NAME' | translate }}" />
        <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <kendo-grid [data]="view.gridData" [loading]="view.loading" [navigable]="true"
      [pageable]="count > view.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
      [pageSize]="view.state.take" [skip]="view.state.skip" [sortable]="true" [sort]="view.state.sort"
      [filterable]="enableAdvanced" [filter]="view.state.filter" [groupable]="enableAdvanced" [group]="view.groups"
      [selectable]="{ mode: 'single' }" [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced"
      (groupChange)="groupChange($event)" (dataStateChange)="dataStateChange($event)">
      <kendo-grid-messages noRecords="{{ 'NO-GROUPS' | translate }}">
      </kendo-grid-messages>
      <kendo-grid-column field="name" title="{{ 'NAME' | translate }}" [width]="25">
      </kendo-grid-column>
      <kendo-grid-column field="description" title="{{ 'DESCRIPTION' | translate }}" [width]="20"></kendo-grid-column>
      <kendo-grid-column field="organizationName" title="{{ 'ORGANIZATION' | translate }}" [width]="25">
      </kendo-grid-column>
      <kendo-grid-column class="text-center" field="active" [width]="15" title="{{ 'ENABLED' | translate }}"
        filter="boolean">
        <ng-template kendoGridCellTemplate let-dataItem>
          <i *ngIf="dataItem.active" class="fas fa-check"></i>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="userCount" title="{{ 'STAFF' | translate }}" [width]="10" filter="numeric"
        format="{0:n}">
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
          </kendo-grid-numeric-filter-cell>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column [width]="10" title="{{ 'ACTIONS' | translate }}" class="text-center">
        <ng-template kendoGridCellTemplate let-dataItem>
          <i class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}" (click)="editHandler(dataItem['id'])">
          </i>
          &nbsp;
          <i class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}" (click)="deleteHandler(dataItem['id'])">
          </i>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
    <button kendoButton [primary]="false" type="button" class="float-right mt-3 mb-3" (click)="addHandler()">
      {{'ADD' | translate}}<i class="far fa-plus"></i>
    </button>

    <!--Deletion confirmation-->
    <kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteDialogOpened" (close)="close('deleteDialog')"
      [minWidth]="250" [width]="450">
      <p>{{ 'CONFIRM-DELETION' | translate }}</p>
      <span class="k-font-weight-bold">{{selectedGroup.name}}</span>
      <kendo-dialog-actions>
        <button kendoButton (click)="deleteAction(false)">{{ 'NO' | translate }}</button>
        <button kendoButton (click)="deleteAction(true)" [primary]="true">{{ 'YES' | translate }}</button>
      </kendo-dialog-actions>
    </kendo-dialog>
  </div>
</div>

<!--Add/Edit form (created only when dialog opens)-->
@if (editDataItem) {
<app-channel-group-edit [model]="editDataItem" [isNew]="isNew" (afterSave)="afterSaveHandler($event)"
  (cancelling)="cancelChangesHandler()">
</app-channel-group-edit>
}